import { AppContext } from "next/app";
import { ReadonlyHeaders } from "next/dist/server/web/spec-extension/adapters/headers";

const testUserAgent = (
  userAgent: string | string[] | undefined | null
): boolean => {
  if (!userAgent) {
    return false;
  }

  // Handle cases where userAgent might be an array (from Node's http.IncomingMessage.headers)
  // or just to be robust. headers().get() returns string | null.
  // window.navigator.userAgent is a string.
  const agentString = Array.isArray(userAgent)
    ? userAgent.join(" ")
    : userAgent;

  return /Moxie Suite/.test(agentString);
};

// Method for Pages router (to be used in _app.tsx) - please remove one we migrate to App Router
export const getIsMoxieMobile = (appContext: AppContext) => {
  try {
    if (appContext.ctx.req) {
      const userAgent = appContext.ctx.req.headers["user-agent"];
      const xRequestedWith = appContext.ctx.req.headers["x-requested-with"];

      return testUserAgent(userAgent) || xRequestedWith === "com.moxie.suite";
    }

    if (typeof window !== "undefined" && window.navigator?.userAgent) {
      return testUserAgent(window.navigator.userAgent);
    }

    return false;
  } catch (e) {
    console.error("MoxieApp.getInitialProps error", e);

    return false;
  }
};

// Client method for App Router (to be used in 'use client' components)
export const getIsMoxieMobileCSR = (): boolean => {
  try {
    if (typeof window !== "undefined" && window.navigator?.userAgent) {
      return testUserAgent(window.navigator.userAgent);
    }

    return false;
  } catch (e) {
    console.error("getIsMoxieMobileCSR error", e);

    return false;
  }
};

// Server method for App Router
export const getIsMoxieMobileSSR = (headersList: ReadonlyHeaders): boolean => {
  try {
    const userAgent = headersList.get("user-agent");
    const xRequestedWith = headersList.get("x-requested-with");

    return testUserAgent(userAgent) || xRequestedWith === "com.moxie.suite";
  } catch (e) {
    // headers() will throw an error if used outside a Server Component context (e.g., in 'use client' or Route Handlers).
    // It's also important that the component calling this is not part of a tree that opts into static rendering if dynamic headers are needed.
    console.error(
      "getIsMoxieMobileSSR error: This function must be called from a Server Component. " +
        "If the calling component is statically rendered, headers might not be available dynamically. " +
        "Original error: ",
      e
    );

    return false;
  }
};
